import React, { createContext, ReactNode } from 'react';
import classNames from 'classnames';

import styles from './Tabs.module.scss';

interface TabsProps<T extends string = string> {
  activeTab: T;
  onTabChange: (tabId: T) => void;
  children: ReactNode;
  className?: string;
}

interface TabsContextValue<T extends string = string> {
  activeTab: T;
  setActiveTab: (tabId: T) => void;
}

export const TabsContext = createContext<TabsContextValue | null>(null);

export function Tabs<T extends string = string>({ activeTab, onTabChange, children, className }: TabsProps<T>) {
  const handleTabChange = (tabId: string) => {
    if (onTabChange) onTabChange(tabId as T);
  };
  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab: handleTabChange }}>
      <div className={classNames(styles.tabsContainer, className)} role="tablist">
        {children}
      </div>
    </TabsContext.Provider>
  );
}
